// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import configData from '@/mixins/config'
import store from '@/store/florist-store'
import {
  BNavItemDropdown,
  BDropdownItem,
  BButton,
  BCollapse,
  BOffcanvas,
  BOverlay,
  BFormGroup,
  BFormTextarea,
  BCard,
  BCardBody,
  BCardHeader
} from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// import 'vue-select/dist/vue-select.css'

const app = createApp(App)

axios.defaults.withCredentials = true
axios.defaults.baseURL = 'https://develop-links-api.hibiyakadan-wedding.com' // 環境により調整
axios.defaults.headers.common['Content-Type'] = 'application/json'
app.config.globalProperties.config = configData.config
app.config.globalProperties.consts = configData.consts
const token = window.localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
app.use(VueAxios, axios)
app.component('BNavItemDropdown', BNavItemDropdown)
app.component('BDropdownItem', BDropdownItem)
app.component('BButton', BButton)
app.component('BCollapse', BCollapse)
app.component('BOffcanvas', BOffcanvas)
app.component('BOverlay', BOverlay)
app.component('BFormGroup', BFormGroup)
app.component('BFormTextarea', BFormTextarea)
app.component('BCard', BCard)
app.component('BCardBody', BCardBody)
app.component('BCardHeader', BCardHeader)

app.use(store)
app.use(router)
app.mount('#app')

/* eslint-disable no-new */
/*  new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})  */
